import React from 'react';
import { withPrefix } from "gatsby";
import { Router, Redirect } from '@reach/router';
import Login from '../components/Login/Login'
import Overview from './overview';
import ThankYou from './thank-you';
import Partners from './partners';

import '../styles/all.scss';

const index = () => {

  return (
    <Router basepath={withPrefix("/")}>
      <Redirect from="/" to={withPrefix("/overview")} noThrow/>
      <Overview path={withPrefix("/")}/>
      <ThankYou path={withPrefix("/")}/>
      <Partners path="partners">
        <Login path="login" component={Login}/>
      </Partners>
    </Router>
  )
};

export default index
